import { Injectable } from '@angular/core';

import { TwcNotificationParams, TwcNotificationService } from '@topcon/twc-angular';

import { LogService } from '../log';
import { TranslationService } from '../translate/translation.service';

/**
 * Service to simplify the emission of notifications
 */
@Injectable({
    providedIn: 'root',
})
export class ToastService {
    constructor(
        private translationService: TranslationService,
        private twcNotificationService: TwcNotificationService,
        private logService: LogService
    ) {}

    /**
     * Sends a generic information notification
     * @param messageKey The translation key or message to emit
     * @param time An optional delay time to close the notification
     */
    generic(messageKey: string, time?: number, showClose = false): void {
        const params: TwcNotificationParams = {
            type: 'generic',
            position: 'bottom',
        };

        if (time) {
            params.time = time;
        }

        params.closeable = showClose;

        this.twcNotificationService.show(this.translationService.translate(messageKey), '', params);
    }

    /**
     * Sends an error message notification
     * @param messageKey The translation key or message to emit
     * @param time An optional delay time to close the notification
     */
    error(messageKey: string, time?: number, showClose = false): void {
        const params: TwcNotificationParams = {
            type: 'error',
        };

        if (time) {
            params.time = time;
        }

        params.closeable = showClose;

        const errorMsg = this.translationService.translate(messageKey);
        this.logService.warn(errorMsg);
        this.twcNotificationService.show(errorMsg, '', params);
    }
}
